/**
 * FounderBadge
 * Purple circle with a golden crown — shown on founder creators' cards.
 * Usage: <FounderBadge size="md" />
 * Sizes: sm (w-5/h-5), md (w-7/h-7), lg (w-9/h-9)
 */
export function FounderBadge({ size = "md", className = "" }) {
  const sizeMap = {
    sm: "w-5 h-5",
    md: "w-7 h-7",
    lg: "w-9 h-9",
  };

  return (
    <div
      className={`${sizeMap[size] || sizeMap.md} rounded-full flex items-center justify-center shrink-0 ${className}`}
      style={{
        backgroundColor: "#6C3BF4",
        boxShadow: "0 2px 8px rgba(108,59,244,0.55)",
      }}
      aria-label="Fundadora"
      title="Creadora Fundadora"
      role="img"
    >
      {/* Crown SVG — 3 peaks, flat base, dots on tips */}
      <svg
        viewBox="0 0 24 24"
        className="w-[60%] h-[60%]"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Crown body */}
        <path
          d="M4 18 L4 12 L8 7 L11 12 L12 4 L13 12 L16 7 L20 12 L20 18 Z"
          fill="#F5C518"
        />
        {/* Base */}
        <rect x="4" y="18" width="16" height="3" rx="1" fill="#F5C518" />
        {/* Tip dots */}
        <circle cx="4"  cy="12" r="1.5" fill="#F5C518" />
        <circle cx="12" cy="4"  r="1.5" fill="#F5C518" />
        <circle cx="20" cy="12" r="1.5" fill="#F5C518" />
      </svg>
    </div>
  );
}
